import React from "react";
import ApproveMasterlist from "./ApproveMasterList";
import ApproveMAsterdata from "./ApproveMasterData";
import { Tab, Tabs } from "react-bootstrap";

function ApproveMasterTab() {
  return (
    <>
      <Tabs
        defaultActiveKey="approvemasterlist"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab
          eventKey="approvemasterlist"
          title="อนุมัติการจดทะเบียนหัวหน้ากลุ่มชาวไร่อ้อย"
        >
          <ApproveMasterlist />
        </Tab>
        <Tab
          eventKey="approvemasterdata"
          title="ข้อมูลการจดทะเบียนหัวหน้ากลุ่มชาวไร่อ้อย"
        >
          <ApproveMAsterdata />
        </Tab>
      </Tabs>
    </>
  );
}

export default ApproveMasterTab;
